import type { Icon } from '@onefootprint/icons';
import {
  IcoBuilding16,
  IcoEye16,
  IcoFingerprint16,
  IcoShield16,
  IcoShieldFlash16,
  IcoWarning16,
} from '@onefootprint/icons';
import type { TFunction } from 'i18next';

export type AskPercyTemplate = {
  id: string;
  title: string;
  icon: Icon;
  prompt: string;
};

const INVESTIGATION_TEMPLATE_IDS = [
  'enhanced_due_diligence',
  'adverse_media_check',
  'sanctions_pep_screening',
  'beneficial_ownership',
  'name_matching',
  'ongoing_monitoring',
] as const;

const INVESTIGATION_TEMPLATE_ICONS = {
  enhanced_due_diligence: IcoShieldFlash16,
  adverse_media_check: IcoWarning16,
  sanctions_pep_screening: IcoShield16,
  beneficial_ownership: IcoBuilding16,
  name_matching: IcoFingerprint16,
  ongoing_monitoring: IcoEye16,
} as const;

export const buildInvestigationTemplates = (t: TFunction<'ask-percy'>): AskPercyTemplate[] =>
  INVESTIGATION_TEMPLATE_IDS.map(id => ({
    id,
    icon: INVESTIGATION_TEMPLATE_ICONS[id],
    title: t($ => $.actionPills.investigationTemplates[id].title),
    prompt: t($ => $.actionPills.investigationTemplates[id].prompt),
  }));
